/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsIn(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M144,104V64a8.0001,8.0001,0,0,1,13.65723-5.65674L172,72.686l30.34277-30.34278a8.00018,8.00018,0,0,1,11.31446,11.31348L183.314,84l14.34327,14.34326A8.00038,8.00038,0,0,1,192,112H152A8.00008,8.00008,0,0,1,144,104Zm-40,40H64a8.00038,8.00038,0,0,0-5.65723,13.65674L72.686,172,42.34277,202.34277a8.00053,8.00053,0,0,0,11.31446,11.31446L84,183.31421l14.34277,14.343A8.00066,8.00066,0,0,0,112,192V152A8.00008,8.00008,0,0,0,104,144Zm79.314,28,14.34327-14.34326A8.00038,8.00038,0,0,0,192,144H152a8.00008,8.00008,0,0,0-8,8v40a8.00053,8.00053,0,0,0,13.65723,5.65723L172,183.31421l30.34277,30.343a8.00053,8.00053,0,0,0,11.31446-11.31446ZM107.06152,56.60889a7.9999,7.9999,0,0,0-8.71875,1.73437L84,72.686,53.65723,42.34326A8.00018,8.00018,0,1,0,42.34277,53.65674L72.686,84,58.34277,98.34326A8.00038,8.00038,0,0,0,64,112h40a8.00008,8.00008,0,0,0,8-8V64A8.00015,8.00015,0,0,0,107.06152,56.60889Z" />
    </Svg>
  );
}

export default ArrowsIn;
